import {
    apiCallCenterFinalizarConsulta,
    apiCallCenterGuardarDatosPaciente,
    apiCallCenterGuardarHistorialClinico,
    apiCallCenterIniciarConsulta,
    apiCallCenterReciclarConsulta,
    apiCallCenterSetColaboradorOnline,
    apiCallCenterStartServiceWithFolio,
    apiColaboradorGetColaboradorEstatus,
    apiColaboradorGetDirectorioEspecialistas,
    apiEspecialidadGetResgistros,
    apiFolioGetReport,
    apiGetColaboradoresCallCenterEspecialistas,
} from "../settings/apiConfig";
import { createContext, useContext, useEffect, useState } from "react";
import {
    directorioPageSize,
    getFormBuscarFolio,
    getFormDiagnostico,
    getFormPaciente,
    getModelTemporizador,
} from "../models/CallCenterModel";
import { fnHandleChangeDate, fnHandleChangeText, fnHandleChangeUDecimal } from "../settings/handleConfig";

import { EnumTipoBusquedaFolio } from "../settings/enumConfig";
import { rxCorreo } from "../settings/regexConfig";
import { useLayout } from "./LayoutContext";
import { useLogin } from "./LoginContext";
import { useRequest } from "./RequestContext";
import { useZoomMeditoc } from "./ZoomMeditocContext";

export const CallCenterContext = createContext();

export function CallCenterProvider(props) {
    const { handleOpenAlert } = useLayout();
    const { usuarioSesion, handleChangeFunctionCloseAll } = useLogin();
    const { Get, Post } = useRequest();
    const { meetingArgs, handleChangeMeetingArgs, handleClickLeaveMeeting } = useZoomMeditoc();

    const [listaColaboradores, setListaColaboradores] = useState([]);
    const [listaEspecialidades, setListaEspecialidades] = useState([]);
    const [paginasTotalesColaboradores, setPaginasTotalesColaboradores] = useState(0);

    //Usado en ZoomMainApp.tsx para activar el useEffect y elimar a todos los participantes de la sala
    const [triggerForRemoveAllParticipans, setTriggerForRemoveAllParticipans] = useState(false);

    const [consultaIniciada, setConsultaIniciada] = useState(false);
    const [entCallCenter, setEntCallCenter] = useState(null);
    const [folioEncontrado, setFolioEncontrado] = useState(null);
    const [usuarioColaborador, setUsuarioColaborador] = useState(null);
    const [colaboradorDisponible, setColaboradorDisponible] = useState(false);
    const [historiaClinica, setHistoriaClinica] = useState({});
    const [intervalColaboradorEstatus, setIntervalColaboradorEstatus] = useState(0);
    const [intervalTemporizador, setIntervalTemporizador] = useState(0);

    const [modalOpenBuscarFolio, setModalOpenBuscarFolio] = useState(false);
    const [modalOpenDirectorio, setModalOpenDirectorio] = useState(false);
    const [modalOpenDetalleHistoriaClinica, setModalOpenDetalleHistoriaClinica] = useState(false);
    const [temporizador, setTemporizador] = useState(getModelTemporizador());
    const [popoverInicio, setPopoverInicio] = useState(false);
    const [popoverOcupado, setPopoverOcupado] = useState(false);
    const [popoverConsulta, setPopoverConsulta] = useState(false);

    const [formDiagnostico, setFormDiagnostico] = useState(getFormDiagnostico());
    const [formBuscarFolio, setFormBuscarFolio] = useState(getFormBuscarFolio());
    const [formPaciente, setFormPaciente] = useState(getFormPaciente());
    const [pacienteEnSala, setPacienteEnSala] = useState(false);

    //Directorio médico
    const [txtBuscador, setTxtBuscador] = useState("");
    const [txtUltimaBusqueda, setTxtUltimaBusqueda] = useState("");
    const [txtEspecilidadFilter, setTxtEspecilidadFilter] = useState("");
    const [paginaActual, setPaginaActual] = useState(1);

    const handleChangePacienteEnSala = (value) => {
        setPacienteEnSala(value);
    };

    const handleOpenBuscarFolio = (value) => {
        setModalOpenBuscarFolio(value);
    };

    const handleOpenDirectorio = (value) => {
        setModalOpenDirectorio(value);
    };

    const handleOpenDetalleHistorialClinico = (value) => {
        setModalOpenDetalleHistoriaClinica(value);
    };

    const handleChangeHistoriaClinica = (value) => {
        setHistoriaClinica(value);
    };

    const handleChangeFormDiagnosticoText = fnHandleChangeText(formDiagnostico, setFormDiagnostico);
    const handleChangeFormDiagnosticoUDec = fnHandleChangeUDecimal(formDiagnostico, setFormDiagnostico);
    const handleChangeFormBuscarFolioText = fnHandleChangeText(formBuscarFolio, setFormBuscarFolio);
    const handleChangeFormPacienteText = fnHandleChangeText(formPaciente, setFormPaciente);
    const handleChangeFormPacienteDate = fnHandleChangeDate(formPaciente, setFormPaciente);

    const handleChangeEspecialidadFilter = async (e) => {
        const especialidad = e.target.value;
        const pagina = 1;
        await fnObtenerDirectorio(especialidad, txtBuscador, pagina);
        setTxtEspecilidadFilter(especialidad);
        setPaginaActual(pagina);
    };

    const handleChangePaginaActual = async (e, page) => {
        await fnObtenerDirectorio(txtEspecilidadFilter, txtBuscador, page);
        setPaginaActual(page);
    };

    const handleChangeBuscadorDirectorio = (e) => {
        const buscador = e.target.value;
        setTxtBuscador(buscador);
    };

    const handleToggleEstatusColaborador = () => {
        fnActualizarEstatus(!colaboradorDisponible, true, true);
    };

    const handleClickBuscarDirectorio = async () => {
        const pagina = 1;
        await fnObtenerDirectorio(txtEspecilidadFilter, txtBuscador, pagina);
        setPaginaActual(pagina);
        setTxtUltimaBusqueda(txtBuscador);
    };

    const handleClickLimpiarDirectorio = async () => {
        const pagina = 1;
        const busqueda = "";
        await fnObtenerDirectorio(txtEspecilidadFilter, busqueda, pagina);
        setPaginaActual(pagina);
        setTxtBuscador(busqueda);
        setTxtUltimaBusqueda(busqueda);
    };

    const handleChangePopoverInicio = (value) => {
        setPopoverInicio(value);
    };

    const handleChangePopoverOcupado = (value) => {
        setPopoverOcupado(value);
    };

    const handleChangePopoverConsulta = (value) => {
        setPopoverConsulta(value);
    };

    const handleClickCloseInicio = () => {
        setPopoverInicio(false);
    };

    const handleClickCloseOcupado = () => {
        setPopoverOcupado(false);
    };

    const handleClickCloseConsulta = () => {
        setPopoverConsulta(false);
    };

    const handleClickCloseDisponible = async () => {
        await fnActualizarEstatus(true, true, true);
        setPopoverInicio(false);
        setPopoverOcupado(false);
    };

    const handleClickCloseReiniciar = () => {
        fnReiniciarChat();
        setPopoverConsulta(false);
    };

    const handleClickIniciarConsulta = () => {
        setPopoverConsulta(false);
        const entFolioRecibidoString = localStorage.getItem("sFolio");
        const entFolioRecibido = JSON.parse(entFolioRecibidoString);

        //console.log("Iniciando consulta...", entFolioRecibido);

        if (entFolioRecibido) {
            if (entFolioRecibido.sFolio && entFolioRecibido.sFolio !== "") {
                //console.log("Se encontró folio", entFolioRecibido.sFolio);
                fnBuscarFolio(entFolioRecibido.sFolio, "1", true);
            } else if (entFolioRecibido.sCorreo && entFolioRecibido.sCorreo !== "") {
                //console.log("Se encontró correo de usuario", entFolioRecibido.sCorreo);
                fnBuscarFolio(entFolioRecibido.sCorreo, "2", true);
            } else {
                //console.log("Sin información de paciente");

                setFormBuscarFolio(getFormBuscarFolio());
                setFolioEncontrado(null);
                setModalOpenBuscarFolio(true);
            }
        } else {
            //console.log("Sin información de paciente");

            setFormBuscarFolio(getFormBuscarFolio());
            setFolioEncontrado(null);
            setModalOpenBuscarFolio(true);
        }
    };

    const handleClickReiniciarChat = () => {
        fnReiniciarChat();
        fnActualizarEstatus(false, true, true);
    };

    const handleClickDirectorio = async () => {
        setModalOpenDirectorio(true);

        //  const [txtBuscador, setTxtBuscador] = useState("");
        //  const [txtUltimaBusqueda, setTxtUltimaBusqueda] = useState("");
        //  const [txtEspecilidadFilter, setTxtEspecilidadFilter] = useState("");
        //  const [paginaActual, setPaginaActual] = useState(1);

        setTxtBuscador("");
        setTxtUltimaBusqueda("");
        setTxtEspecilidadFilter("");
        setPaginaActual(1);

        await fnObtenerEspecialidades();
        await fnObtenerDirectorio(null, "", 1);
    };

    const handleClickBuscarFolio = () => {
        const { txtBuscarFolio, txtTipoBusqueda } = formBuscarFolio;
        const formValidado = {
            ...formBuscarFolio,
            txtBuscarFolio: { ...txtBuscarFolio, error: txtBuscarFolio.value === "" },
        };

        setFormBuscarFolio(formValidado);
        if (
            Object.values(formValidado)
                .map((x) => x.error)
                .includes(true)
        ) {
            return;
        }

        fnBuscarFolio(txtBuscarFolio.value, txtTipoBusqueda.value, false);
    };

    const handleClickLimpiarBuscarFolio = () => {
        setFolioEncontrado(null);
        setFormBuscarFolio(getFormBuscarFolio());
    };

    const handleClickIniciarConsultaFormBuscarFolio = () => {
        if (folioEncontrado) {
            fnCrearConsulta(!folioEncontrado.iIdUsuario ? folioEncontrado.sFolio : "", folioEncontrado.iIdUsuario);
        } else {
            handleOpenAlert("No se ha encontrado ningún folio.");
        }
    };

    const handleClickReciclarConsulta = () => {
        fnReciclarConsulta(entCallCenter.entConsulta.iIdConsulta);
    };

    const handleClickFinalizarConsulta = async (unload) => {
        const {
            txtCCSintomas,
            txtCCDiagnostico,
            txtCCTratamiento,
            txtCCPeso,
            txtCCAltura,
            txtCCAlergias,
            txtCCComentarios,
        } = formDiagnostico;

        const historialClinico = {
            iIdConsulta: entCallCenter.entConsulta.iIdConsulta,
            sSintomas: txtCCSintomas.value,
            sDiagnostico: txtCCDiagnostico.value,
            sTratamiento: txtCCTratamiento.value,
            fPeso: txtCCPeso.value === "" ? null : parseFloat(txtCCPeso.value),
            fAltura: txtCCAltura.value === "" ? null : parseFloat(txtCCAltura.value),
            sAlergias: txtCCAlergias.value,
            sComentarios: txtCCComentarios.value,
            iIdUsuarioMod: usuarioSesion.iIdUsuario,
            entUsuarioMeditoc: entCallCenter.entUsuarioMeditoc,
        };

        await fnGuardarHistorialClinico(historialClinico, unload);
    };

    const handleClickDetalleHistoriaClinica = () => {
        setModalOpenDetalleHistoriaClinica(true);
    };

    const handleClickActualizarDatosPaciente = () => {
        const { txtCCNombre, txtCCTelefono, txtCCCorreo, txtCCFechaNacimiento, txtCCTipoSangre, txtCCSexo } =
            formPaciente;

        const telefono = txtCCTelefono.value.replace(/ /g, "");
        const formValidado = {
            ...formPaciente,
            txtCCNombre: { ...txtCCNombre, error: txtCCNombre.value === "" },
            txtCCTelefono: { ...txtCCTelefono, error: telefono.length !== 10 },
            txtCCCorreo: { ...txtCCCorreo, error: !rxCorreo.test(txtCCCorreo.value) },
        };

        setFormPaciente(formValidado);
        if (
            Object.values(formValidado)
                .map((x) => x.error)
                .includes(true)
        ) {
            return;
        }

        const entPaciente = {
            iIdPaciente: entCallCenter.entPaciente.iIdPaciente,
            sNombre: txtCCNombre.value,
            sCorreo: txtCCCorreo.value,
            sTelefono: txtCCTelefono.value,
            sTipoSangre: txtCCTipoSangre.value,
            dtFechaNacimiento: !txtCCFechaNacimiento.value ? null : txtCCFechaNacimiento.value.toLocaleDateString(),
            iIdSexo: parseInt(txtCCSexo.value),
            iIdUsuarioMod: usuarioSesion.iIdUsuario,
            entUsuarioMeditoc: entCallCenter.entUsuarioMeditoc,
        };
        fnActualizarDatosPacientes(entPaciente);
    };

    const handleClickStartCallCenter = async () => {
        localStorage.removeItem("name");
        localStorage.removeItem("SalaID");
        localStorage.removeItem("screen");
        localStorage.removeItem("sessionId");
        localStorage.removeItem("DisplayName");
        await fnObtenerColaborador();
    };

    const fnIniciarTemporizador = () => {
        //console.log("Iniciando temporizador");
        let temp = getModelTemporizador();
        const fnUpdTemporizador = () => {
            temp = {
                segundo: temp.segundo === 59 ? 0 : temp.segundo + 1,
                minuto:
                    temp.segundo === 59 && temp.minuto === 59 ? 0 : temp.segundo === 59 ? temp.minuto + 1 : temp.minuto,
                hora: temp.segundo === 59 && temp.minuto === 59 ? temp.hora + 1 : temp.hora,
            };
            setTemporizador(temp);
        };
        const intervalTemp = setInterval(fnUpdTemporizador, 1000);
        setIntervalTemporizador(intervalTemp);
    };

    const fnDetenerTemporizador = () => {
        clearInterval(intervalTemporizador);
    };

    const fnReiniciarTemporizador = () => {
        //console.log("Reiniciando temporizador...");
        setTemporizador(getModelTemporizador());
    };

    const fnReiniciarChat = (close = false) => {
        // const iframeickelink = document.getElementById("iframeickelink");

        // if (iframeickelink) {
        //     if (iframeickelink.contentWindow) {
        //         if (typeof iframeickelink.contentWindow.CallBack === "function") {
        //             iframeickelink.contentWindow.CallBack();
        //         }

        //         if (iframeickelink.contentWindow.CallBacks) {
        //             if (typeof iframeickelink.contentWindow.CallBacks.FinalizarConsulta === "function") {
        //                 iframeickelink.contentWindow.CallBacks.FinalizarConsulta();
        //             }
        //         }
        //     }
        // }
        // handleClickLeaveMeeting();
        // if (usuarioColaborador) {
        //     handleChangeMeetingArgs(usuarioColaborador.iNumSala.toString(), usuarioColaborador.sNombreDirectorio);
        // }
        if (meetingArgs) {
            //console.log("Check for meeting", close, meetingArgs);
            if (close) {
                setTriggerForRemoveAllParticipans(null);
            } else {
                setTriggerForRemoveAllParticipans(!triggerForRemoveAllParticipans);
            }
        }
        setPacienteEnSala(false);
        localStorage.removeItem("sFolio");
    };

    const fnFillFormPaciente = (entCallCenter) => {
        const { entFolio, entPaciente, entUsuarioMeditoc } = entCallCenter;
        const {
            txtCCFolio,
            txtCCNombre,
            txtCCTelefono,
            txtCCCorreo,
            txtCCFechaNacimiento,
            txtCCTipoSangre,
            txtCCSexo,
        } = formPaciente;

        setFormPaciente({
            ...formPaciente,
            txtCCFolio: {
                ...txtCCFolio,
                value: entUsuarioMeditoc ? entUsuarioMeditoc.sCorreo : !entFolio.sFolio ? "" : entFolio.sFolio,
            },
            txtCCNombre: { ...txtCCNombre, value: !entPaciente.name ? "" : entPaciente.name },
            txtCCTelefono: { ...txtCCTelefono, value: !entPaciente.phone ? "" : entPaciente.phone },
            txtCCCorreo: { ...txtCCCorreo, value: !entPaciente.email ? "" : entPaciente.email },
            txtCCFechaNacimiento: {
                ...txtCCFechaNacimiento,
                value: !entPaciente.dtFechaNacimiento ? null : new Date(entPaciente.dtFechaNacimiento),
            },
            txtCCTipoSangre: { ...txtCCTipoSangre, value: !entPaciente.sTipoSangre ? "" : entPaciente.sTipoSangre },
            txtCCSexo: { ...txtCCSexo, value: !entPaciente.iIdSexo ? "" : entPaciente.iIdSexo.toString() },
        });
    };

    const fnCerrarCallCenter = async () => {
        //console.log("Inicia cerre de sesión");
        await fnActualizarEstatus(false, false, false);
        if (consultaIniciada) await handleClickFinalizarConsulta(true);
        handleClickLeaveMeeting();
        fnReiniciarChat(true);
    };

    const fnConfigurarSalaIceLink = async (usuarioColaborador) => {
        // handleChangeMeetingArgs(false, false);
        handleChangeMeetingArgs(usuarioColaborador.iNumSala.toString(), usuarioColaborador.sNombreDirectorio);
        // localStorage.setItem("name", usuarioColaborador.sNombreDirectorio);
        // localStorage.setItem("SalaID", usuarioColaborador.iNumSala);
        // localStorage.setItem("screen", 0);
        // localStorage.setItem("sessionId", usuarioColaborador.iNumSala);
        // localStorage.setItem("DisplayName", usuarioColaborador.sNombreDirectorio);
        // localStorage.removeItem("sFolio");
        // const getUIID = () => new Date().getTime() * 1000 + Math.floor(Math.random() * 1001);
        // const url = urlBase + "/IceLink/index.html?var=" + getUIID();
        // const sala = (
        //     <iframe
        //         id="iframeickelink"
        //         title="iframeickelink"
        //         src={url}
        //         width="100%"
        //         height="650px"
        //         style={{ border: "none" }}
        //         scrolling="no"
        //     />
        // );
        // setSalaIceLink(sala);
        // await fnActualizarEstatus(false, true, true);
        setPopoverInicio(true);

        window.onbeforeunload = () => "¿Desea salir del consultorio virtual?";
        window.onunload = fnCerrarCallCenter;
    };

    const fnActualizarEstatus = async (disponible, online) => {
        if (!usuarioColaborador) return;

        // const messageError = "No se puede marcar como DISPONIBLE hasta que la sala se haya cargado por completo";

        if (disponible && consultaIniciada) {
            handleOpenAlert("No se puede marcar como DISPONIBLE hasta que la consulta haya finalizado", "warning");
            return;
        }
        // if (disponible && online) {
        //     const frameIceLink = document.getElementById("iframeickelink");
        //     if (frameIceLink) {
        //         if (typeof frameIceLink.contentWindow.CallBack !== "function") {
        //             handleOpenAlert(messageError, "warning");
        //             return;
        //         }
        //         if (typeof frameIceLink.contentWindow.CallBacks.FinalizarConsulta !== "function") {
        //             handleOpenAlert(messageError, "warning");
        //             return;
        //         }
        //     } else {
        //         handleOpenAlert(messageError, "warning");
        //         return;
        //     }
        // }

        if (disponible && online && pacienteEnSala) {
            handleOpenAlert(
                "No se puede marcar como DISPONIBLE mientras haya un paciente en la sala. Reinicie chat para expulsar a los pacientes",
                "warning"
            );
            return;
        }

        const payload = {
            loader: "Actualizando estatus del colaborador...",
            url: apiCallCenterSetColaboradorOnline,
            body: {
                iIdColaborador: usuarioColaborador.iIdColaborador,
                iIdUsuarioMod: usuarioSesion.iIdUsuario,
                bOnline: online,
                bOcupado: !disponible,
            },
            alert: true,
        };

        const response = await Post(payload);
        if (response.Code === 0) {
            if (online) {
                setColaboradorDisponible(disponible);
            }
            // if (disponible) {
            //     fnReiniciarChat();
            // } else {
            //     handleClickLeaveMeeting();
            // }
        }
    };

    const fnIniciarConsulta = async (iIdConsulta = 0) => {
        //console.log("Iniciando consulta...", iIdConsulta);
        const payload = {
            loader: "Iniciando consulta...",
            url:
                apiCallCenterIniciarConsulta +
                "?iIdConsulta=" +
                iIdConsulta +
                "&iIdColaborador=" +
                usuarioColaborador.iIdColaborador +
                "&iIdUsuarioMod=" +
                usuarioSesion.iIdUsuario,
            body: {},
            alert: true,
        };

        const response = await Post(payload);

        //console.log("Respuesta de inicialización de consulta", response);

        if (response.Code === 0) {
            setConsultaIniciada(true);
            await fnActualizarEstatus(false, true, true);
            fnReiniciarTemporizador();
            fnIniciarTemporizador();
        }
    };

    const fnCrearConsulta = async (sFolio = "", iIdUsuario = "") => {
        //console.log("Creando consulta...", sFolio, iIdUsuario);
        const payload = {
            loader: "Creando consulta...",
            url:
                apiCallCenterStartServiceWithFolio +
                "?iIdColaborador=" +
                usuarioColaborador.iIdColaborador +
                "&sFolio=" +
                sFolio +
                "&iIdUsuario=" +
                iIdUsuario +
                "&iIdUsuarioMod=" +
                usuarioSesion.iIdUsuario,
            body: {},
            alert: true,
        };

        const response = await Post(payload);

        //console.log("Respuesta de creación de consulta", response);

        if (response.Code === 0) {
            setEntCallCenter(response.Result);
            fnFillFormPaciente(response.Result);
            setModalOpenBuscarFolio(false);
            await fnIniciarConsulta(response.Result.entConsulta.iIdConsulta);
        }
    };

    const fnBuscarFolio = async (folio, tipoBusqueda, inicioAutomatico) => {
        const payload = {
            loader: "Buscando folio...",
            url: apiFolioGetReport + "?psFolio=" + folio + "&pbActivo=&pbBaja=" + "&piTipoBusqueda=" + tipoBusqueda,
            alert: true,
        };

        const response = await Get(payload);
        //console.log("Respuesta de consulta de información de folio", response);

        if (response.Code === 0) {
            if (response.Result.length > 0) {
                let ultimoFolio = response.Result[response.Result.length - 1];
                setFolioEncontrado(ultimoFolio);

                //console.log("Se encontró información de folio", ultimoFolio);

                if (inicioAutomatico) {
                    //console.log("Iniciando consulta automática...");

                    await fnCrearConsulta(!ultimoFolio.iIdUsuario ? ultimoFolio.sFolio : "", ultimoFolio.iIdUsuario);
                }
            } else {
                setFolioEncontrado(null);
                handleOpenAlert("No se encontró el folio o ha expirado.");
            }
        } else {
            setFolioEncontrado(null);
        }
    };

    const fnGuardarHistorialClinico = async (historialClinico, unload = false) => {
        const payload = {
            loader: "Guardando historial clínico...",
            url: apiCallCenterGuardarHistorialClinico,
            body: historialClinico,
            alert: true,
        };

        const response = await Post(payload);
        if (response.Code === 0) {
            setFormDiagnostico(getFormDiagnostico());
            await fnFinalizarConsulta(entCallCenter.entConsulta.iIdConsulta, usuarioColaborador.iIdColaborador, unload);
        }
        return response;
    };

    const fnFinalizarConsulta = async (iIdConsulta = 0, iIdColaborador = 0, unload = false) => {
        const payload = {
            loader: "Finalizando consulta...",
            url:
                apiCallCenterFinalizarConsulta +
                "?iIdConsulta=" +
                iIdConsulta +
                "&iIdColaborador=" +
                iIdColaborador +
                "&iIdUsuarioMod=" +
                usuarioSesion.iIdUsuario,
            body: {},
            alert: true,
        };

        const response = await Post(payload);
        if (response.Code === 0) {
            fnDetenerTemporizador();
            fnReiniciarTemporizador();
            setEntCallCenter(null);
            setFolioEncontrado(null);
            setFormDiagnostico(getFormDiagnostico());
            setFormPaciente(getFormPaciente());
            setFormBuscarFolio(getFormBuscarFolio());
            setConsultaIniciada(false);
            fnReiniciarChat();
        }
    };

    const fnReciclarConsulta = async (iIdConsulta = 0) => {
        const payload = {
            loader: "Reciclando consulta...",
            url:
                apiCallCenterReciclarConsulta +
                "?iIdConsulta=" +
                iIdConsulta +
                "&iIdUsuarioMod=" +
                usuarioSesion.iIdUsuario,
            body: {},
            alert: true,
        };

        const response = await Post(payload);
        if (response.Code === 0) {
            fnDetenerTemporizador();
            fnReiniciarTemporizador();
            setEntCallCenter(null);
            setFolioEncontrado(null);
            setFormDiagnostico(getFormDiagnostico());
            setFormPaciente(getFormPaciente());
            setFormBuscarFolio(getFormBuscarFolio());
            setConsultaIniciada(false);
            fnReiniciarChat();
        }
    };

    const fnObtenerColaborador = async () => {
        const payload = {
            loader: "Consultando información del colaborador...",
            url: apiGetColaboradoresCallCenterEspecialistas + "?piIdUsuarioCGU=" + usuarioSesion.iIdUsuario,
            alert: false,
        };

        const response = await Get(payload);
        if (response.Code === 0) {
            if (response.Result.length < 1) {
                handleOpenAlert("No se ha ingresado con una cuenta de colaborador.");
                setUsuarioColaborador(null);
                return;
            }
            const colaborador = response.Result[0];
            if (!colaborador.bAcceso) {
                handleOpenAlert("Aún no cuenta con acceso a las consultas de Meditoc Call Center.");
                setUsuarioColaborador(null);
                return;
            }
            if (!colaborador.iNumSala || colaborador.iNumSala < 100000) {
                handleOpenAlert("No hay un número de sala asignado a esta cuenta.");
                setUsuarioColaborador(null);
                return;
            }
            setUsuarioColaborador(colaborador);
            setTemporizador(getModelTemporizador());
            clearInterval(intervalTemporizador);
        } else {
            setUsuarioColaborador(null);
        }
    };

    const fnObtenerEspecialidades = async () => {
        const payload = {
            loader: "Consultando especialidades...",
            url: apiEspecialidadGetResgistros,
            alert: false,
        };

        const response = await Get(payload);
        if (response.Code === 0) {
            setListaEspecialidades(response.Result);
        }
    };

    const fnObtenerDirectorio = async (especialidad = null, buscador = "", page = null) => {
        const payload = {
            loader: "Consultando directorio médico",
            url:
                apiColaboradorGetDirectorioEspecialistas +
                "?piIdEspecialidad=" +
                especialidad +
                "&psBuscador=" +
                buscador +
                "&piPage=" +
                page +
                "&piPageSize=" +
                directorioPageSize,
            alert: false,
        };
        const response = await Get(payload);
        if (response.Code === 0) {
            const { iTotalPaginas, lstColaboradores } = response.Result;
            setPaginasTotalesColaboradores(iTotalPaginas);
            setListaColaboradores(lstColaboradores);
        }
    };

    const fnComprobarEstatusColaborador = async () => {
        const payload = {
            url: apiColaboradorGetColaboradorEstatus + "?piIdColaborador=" + usuarioColaborador.iIdColaborador,
        };

        const response = await Get(payload);
        if (response.Code === 0) {
            const { bOcupado } = response.Result;
            if (bOcupado) {
                await fnActualizarEstatus(false, true, true);
                const sFolioGuardado = localStorage.getItem("sFolio");
                if (sFolioGuardado) {
                    setPopoverConsulta(true);
                } else {
                    setPopoverOcupado(true);
                }
                clearInterval(intervalColaboradorEstatus);
            }
        }
    };

    const fnActualizarDatosPacientes = async (entPaciente) => {
        const payload = {
            loader: "Actualizando datos del paciente...",
            url: apiCallCenterGuardarDatosPaciente,
            body: entPaciente,
            alert: true,
        };

        const response = await Post(payload);
        if (response.Code === 0) {
            setEntCallCenter({
                ...entCallCenter,
                entPaciente: {
                    ...entCallCenter.entPaciente,
                    name: entPaciente.sNombre,
                    email: entPaciente.sCorreo,
                    phone: entPaciente.sTelefono,
                    dtFechaNacimiento: new Date(entPaciente.dtFechaNacimiento),
                    sTipoSangre: entPaciente.sTipoSangre,
                    iIdSexo: entPaciente.iIdSexo,
                },
            });
        }
    };

    useEffect(() => {
        if (usuarioColaborador) {
            fnConfigurarSalaIceLink(usuarioColaborador);
        }
        // eslint-disable-next-line
    }, [usuarioColaborador]);

    useEffect(() => {
        if (usuarioColaborador) {
            if (colaboradorDisponible) {
                const interval = setInterval(fnComprobarEstatusColaborador, 30000);
                setIntervalColaboradorEstatus(interval);
            } else {
                clearInterval(intervalColaboradorEstatus);
            }
            // handleChangeMeetingArgs(usuarioColaborador.iNumSala.toString(), usuarioColaborador.sNombreDirectorio);
        }
        // eslint-disable-next-line
    }, [colaboradorDisponible]);

    useEffect(() => {
        const {
            txtBuscarFolio,
            txtTipoBusqueda,
            txtBuscarNombrePaciente,
            txtBuscarTelefonoPaciente,
            txtBuscarCorreoPaciente,
        } = formBuscarFolio;

        if (folioEncontrado) {
            const sinInfo = "(Sin información)";
            setFormBuscarFolio({
                ...formBuscarFolio,
                txtBuscarFolio: {
                    ...txtBuscarFolio,
                    value:
                        txtTipoBusqueda.value === EnumTipoBusquedaFolio.folio
                            ? folioEncontrado.sFolio
                            : folioEncontrado.sCorreoPaciente,
                },
                txtBuscarNombrePaciente: {
                    ...txtBuscarNombrePaciente,
                    value: !folioEncontrado.sNombrePaciente ? sinInfo : folioEncontrado.sNombrePaciente,
                },
                txtBuscarTelefonoPaciente: {
                    ...txtBuscarTelefonoPaciente,
                    value: !folioEncontrado.sTelefonoPaciente ? sinInfo : folioEncontrado.sTelefonoPaciente,
                },
                txtBuscarCorreoPaciente: {
                    ...txtBuscarCorreoPaciente,
                    value: !folioEncontrado.sCorreoPaciente ? sinInfo : folioEncontrado.sCorreoPaciente,
                },
            });
        } else {
            setFormBuscarFolio({
                ...getFormBuscarFolio(),
                txtBuscarFolio,
            });
        }
        // eslint-disable-next-line
    }, [folioEncontrado]);

    useEffect(() => {
        if (entCallCenter) {
            const { txtCCAltura, txtCCPeso, txtCCAlergias } = formDiagnostico;
            const { lstHistorialClinico, entUsuarioMeditoc } = entCallCenter;

            if (lstHistorialClinico) {
                const historiales = lstHistorialClinico.length;
                if (historiales > 0) {
                    const ultimoHistorial = lstHistorialClinico[historiales - 1];
                    setFormDiagnostico({
                        ...formDiagnostico,
                        txtCCAltura: {
                            ...txtCCAltura,
                            value: ultimoHistorial.fAltura,
                        },
                        txtCCPeso: {
                            ...txtCCPeso,
                            value: ultimoHistorial.fPeso,
                        },
                        txtCCAlergias: {
                            ...txtCCAlergias,
                            value: ultimoHistorial.sAlergias,
                        },
                    });
                }
            }
            if (entUsuarioMeditoc) {
                setFormDiagnostico({
                    ...formDiagnostico,
                    txtCCAltura: {
                        ...txtCCAltura,
                        value: !entUsuarioMeditoc.fAltura ? "" : entUsuarioMeditoc.fAltura,
                    },
                    txtCCPeso: {
                        ...txtCCPeso,
                        value: !entUsuarioMeditoc.fPeso ? "" : entUsuarioMeditoc.fPeso,
                    },
                });
            }
        }
        // eslint-disable-next-line
    }, [entCallCenter]);

    useEffect(() => {
        handleChangeFunctionCloseAll(() => fnCerrarCallCenter);
        // eslint-disable-next-line
    }, [
        entCallCenter,
        consultaIniciada,
        usuarioSesion,
        usuarioColaborador,
        pacienteEnSala,
        triggerForRemoveAllParticipans,
    ]);

    return (
        <CallCenterContext.Provider
            value={{
                listaColaboradores,
                listaEspecialidades,
                paginasTotalesColaboradores,
                consultaIniciada,
                entCallCenter,
                folioEncontrado,
                usuarioColaborador,
                colaboradorDisponible,
                historiaClinica,
                intervalColaboradorEstatus,
                intervalTemporizador,
                modalOpenBuscarFolio,
                modalOpenDirectorio,
                modalOpenDetalleHistoriaClinica,
                temporizador,
                popoverInicio,
                popoverOcupado,
                popoverConsulta,
                formDiagnostico,
                formBuscarFolio,
                formPaciente,
                txtBuscador,
                txtUltimaBusqueda,
                txtEspecilidadFilter,
                paginaActual,
                triggerForRemoveAllParticipans,
                fnActualizarEstatus,
                handleOpenBuscarFolio,
                handleOpenDirectorio,
                handleOpenDetalleHistorialClinico,
                handleChangePopoverInicio,
                handleChangePopoverOcupado,
                handleChangePopoverConsulta,
                handleChangeHistoriaClinica,
                handleChangeFormDiagnosticoText,
                handleChangeFormDiagnosticoUDec,
                handleChangeFormBuscarFolioText,
                handleChangeFormPacienteText,
                handleChangeFormPacienteDate,
                handleChangeEspecialidadFilter,
                handleChangePaginaActual,
                handleChangeBuscadorDirectorio,
                handleChangePacienteEnSala,
                handleToggleEstatusColaborador,
                handleClickBuscarDirectorio,
                handleClickLimpiarDirectorio,
                handleClickCloseInicio,
                handleClickCloseOcupado,
                handleClickCloseConsulta,
                handleClickCloseDisponible,
                handleClickCloseReiniciar,
                handleClickIniciarConsulta,
                handleClickReiniciarChat,
                handleClickDirectorio,
                handleClickBuscarFolio,
                handleClickLimpiarBuscarFolio,
                handleClickReciclarConsulta,
                handleClickFinalizarConsulta,
                handleClickIniciarConsultaFormBuscarFolio,
                handleClickDetalleHistoriaClinica,
                handleClickActualizarDatosPaciente,
                handleClickStartCallCenter,
            }}
        >
            {props.children}
        </CallCenterContext.Provider>
    );
}

export function useCallCenter() {
    return useContext(CallCenterContext);
}
